<mat-card [ngClass]="bgClass" matElevation defaultElevation="4" raisedElevation="16">
    <mat-card-header>
        <div mat-card-avatar>
            <fa-icon class="icon-lg" [icon]="['fal', icon]"></fa-icon>
            <!--
      <mat-icon class="icon-lg">{{ icon }}</mat-icon>
      -->
        </div>
        @if (_format) {
            <mat-card-title>{{ _count | money: currencyType }}</mat-card-title>
        }
        @if (!_format) {
            <mat-card-title>{{ _count }}</mat-card-title>
        }
        <mat-card-subtitle>{{ label }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content fxFlexAlign="stretch">
        <div style="height: 100%">
            {{ content }}
        </div>
    </mat-card-content>
    <mat-card-actions>
        @if (url) {
            <a
                (click)="goToDetails()"
                [href]="url"
                class="float-right card-inverse details"
                style="float: left; opacity: 0.6">
                {{ 'GENERAL.TITLE.DETAILS' | translate }}
            </a>
        }
        <fa-icon matSuffix
            (click)="refresh()"
            style="font-size: 16px; float: right; cursor: pointer"
            [icon]="['fal', 'sync']"
            [animation]="_refreshing ? 'spin' : undefined" />
    </mat-card-actions>
</mat-card>
